/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, of: NonNullable<unknown> }} Loud_Happy_Newt_LookInputs */

const en_loud_happy_newt_look = /** @type {(inputs: Loud_Happy_Newt_LookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.of}`)
};

const de_loud_happy_newt_look = /** @type {(inputs: Loud_Happy_Newt_LookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.of}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {of}" |
*
* @param {Loud_Happy_Newt_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const loud_happy_newt_look = /** @type {((inputs: Loud_Happy_Newt_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Happy_Newt_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loud_happy_newt_look(inputs)
	return de_loud_happy_newt_look(inputs)
});